import { FlightRatingsEnum } from "@b2bportal/core-types";

export const useFareKeys = () => {
  return [
    FlightRatingsEnum[FlightRatingsEnum.basic],
    FlightRatingsEnum[FlightRatingsEnum.standard],
    FlightRatingsEnum[FlightRatingsEnum.premium],
    FlightRatingsEnum[FlightRatingsEnum.luxury],
  ];
};
